export const timePicker = {
  clockIcon: {
    alt: 'Abrir relógio'
  },
  clearIcon: {
    alt: 'Apagar o tempo'
  }
};
